module.exports = __webpack_public_path__ + "static/media/main_image.251a6772.png";